import { type View, worldToScreen, boundsOf } from "../../../mapCalibration";

export interface Ctx2D {
  beginPath(): void; moveTo(x: number, y: number): void; lineTo(x: number, y: number): void; closePath(): void;
  fill(): void; stroke(): void; fillRect(x: number, y: number, w: number, h: number): void;
  strokeRect(x: number, y: number, w: number, h: number): void; fillText(t: string, x: number, y: number): void;
  save(): void; restore(): void;
  fillStyle: string | CanvasPattern | CanvasGradient; strokeStyle: string | CanvasPattern | CanvasGradient;
  lineWidth: number; globalAlpha: number; font: string;
}

export const PLAN_SMOOTHING = false;

export function drawRing(ctx: Ctx2D, view: View, ring: number[][], stroke: string, fill: string | null, lineWidth: number, alpha = 1): void {
  if (ring.length < 2) return;
  ctx.save();
  ctx.beginPath();
  ring.forEach(([x, y], i) => {
    const [sx, sy] = worldToScreen(view, x, y);
    if (i === 0) ctx.moveTo(sx, sy); else ctx.lineTo(sx, sy);
  });
  ctx.closePath();
  if (fill) { ctx.globalAlpha = alpha; ctx.fillStyle = fill; ctx.fill(); }
  ctx.globalAlpha = 1;
  ctx.strokeStyle = stroke; ctx.lineWidth = lineWidth; ctx.stroke();
  ctx.restore();
}

export function drawHandles(ctx: Ctx2D, view: View, ring: number[][], color: string, sizePx = 6): void {
  ctx.save();
  ctx.fillStyle = color;
  for (const [x, y] of ring) {
    const [sx, sy] = worldToScreen(view, x, y);
    ctx.fillRect(sx - sizePx / 2, sy - sizePx / 2, sizePx, sizePx);
  }
  ctx.restore();
}

/** Direction arrow for one_way zones: `rad` measured from +x towards +y (south), ADR 25 frame. */
export function drawArrow(ctx: Ctx2D, view: View, at: [number, number], rad: number, color: string, lengthM = 2): void {
  const tip: [number, number] = [at[0] + Math.cos(rad) * lengthM, at[1] + Math.sin(rad) * lengthM];
  const [ax, ay] = worldToScreen(view, at[0], at[1]);
  const [tx, ty] = worldToScreen(view, tip[0], tip[1]);
  const head = 6, ang = Math.atan2(ty - ay, tx - ax);
  ctx.save();
  ctx.strokeStyle = color; ctx.fillStyle = color; ctx.lineWidth = 2;
  ctx.beginPath(); ctx.moveTo(ax, ay); ctx.lineTo(tx, ty); ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(tx, ty);
  ctx.lineTo(tx - head * Math.cos(ang - Math.PI / 6), ty - head * Math.sin(ang - Math.PI / 6));
  ctx.lineTo(tx - head * Math.cos(ang + Math.PI / 6), ty - head * Math.sin(ang + Math.PI / 6));
  ctx.closePath(); ctx.fill();
  ctx.restore();
}

export function labelVisible(view: View, ring: number[][], minPx = 12): boolean {
  const b = boundsOf([ring as [number, number][]]);
  return !!b && (b.maxX - b.minX) * view.ppm >= minPx * 3 && (b.maxY - b.minY) * view.ppm >= minPx;
}
